/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AlterarDataAdmissaoAliases {
  CARD_0 = 'card-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_NOVA = 'date-field-nova',
  FETCH_ABERTA = 'fetch-aberta',
  FIELD_ATUAL = 'field-atual',
  FIELD_DATA_NOVA = 'field-data-nova',
  FIELD_TOAST = 'field-toast',
  FORM_DATA_ADMISSAO = 'form-data-admissao',
  MAPPER_1 = 'mapper-1',
  PANEL_0 = 'panel-0',
  PANEL_DATA_ADMISSAO = 'panel-data-admissao',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { AlterarDataAdmissaoAliases };
